(function () {
  var mediaSelector = '.customily_gallery_media, .canvas-container';
  var guardSelector = mediaSelector + ', canvas.upper-canvas, canvas.lower-canvas, .upper-canvas, .lower-canvas';
  var shieldClass = 'ss-customily-scroll-shield';
  var mobileQuery = window.matchMedia && window.matchMedia('(max-width: 749px)');
  var records = [];
  var root = null;
  var treeObserver = null;
  var mountObserver = null;
  var geometryObserver = null;
  var resizeObserver = null;
  var discoveryTimer = null;
  var frame = null;
  var needsScan = false;
  var nextId = 0;
  var tracking = false;
  var startX = 0;
  var startY = 0;

  function isMobile() { return !!(mobileQuery && mobileQuery.matches); }
  function connected(node) { return !!(node && node.isConnected); }
  function matchesMedia(node) {
    return node && node.nodeType === 1 &&
      (node.matches(mediaSelector) || !!node.querySelector(mediaSelector));
  }
  function setStyle(node, key, value) {
    if (node.style[key] !== value) node.style[key] = value;
  }

  function watchGeometry() {
    if (geometryObserver) geometryObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    geometryObserver = new MutationObserver(function () { schedule(false); });
    resizeObserver = window.ResizeObserver ? new ResizeObserver(function () { schedule(false); }) : null;
    var watched = [];
    records.forEach(function (record) {
      var node = record.media;
      // Observe only these gallery elements and their layout ancestors, never
      // every descendant's styles. Shields live outside this product subtree.
      while (node && node !== document.body && node !== document.documentElement) {
        if (watched.indexOf(node) === -1) {
          watched.push(node);
          geometryObserver.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
          if (resizeObserver) resizeObserver.observe(node);
        }
        if (node === root) break;
        node = node.parentElement;
      }
    });
  }

  function scan() {
    if (!root || !isMobile()) return;
    var old = records;
    var media = Array.prototype.slice.call(root.querySelectorAll(mediaSelector));
    if (root.matches && root.matches(mediaSelector)) media.unshift(root);
    // A Customily gallery can contain a translated canvas slide. The outer
    // gallery already shields that area; an inner shield would overlap it and
    // could remain over the previous slide while its canvas moves offscreen.
    media = media.filter(function (node) {
      return !media.some(function (other) { return other !== node && other.contains(node); });
    });
    records = media.map(function (node) {
      var existing = old.filter(function (record) { return record.media === node; })[0];
      if (existing) return existing;
      var shield = document.createElement('div');
      shield.id = 'ss-customily-scroll-shield-' + nextId++;
      shield.className = shieldClass;
      shield.setAttribute('aria-hidden', 'true');
      shield.style.display = 'none';
      document.body.appendChild(shield);
      return { media: node, shield: shield };
    });
    old.forEach(function (record) {
      if (records.indexOf(record) === -1) record.shield.remove();
    });
    if (records.length && discoveryTimer !== null) {
      window.clearTimeout(discoveryTimer);
      discoveryTimer = null;
      if (mountObserver) mountObserver.disconnect();
    }
    if (!records.length) watchMount();
    watchGeometry();
  }

  function positionShields() {
    if (!isMobile()) return;
    // Finish all layout reads before any shield style is changed.
    var positions = records.map(function (record) {
      return { record: record, rect: connected(record.media) ? record.media.getBoundingClientRect() : null };
    });
    positions.forEach(function (position) {
      var shield = position.record.shield;
      var rect = position.rect;
      var visible = rect && rect.width >= 20 && rect.height >= 20;
      if (shield.hidden === !!visible) shield.hidden = !visible;
      // Author CSS uses display:block, which can override the UA [hidden] rule.
      setStyle(shield, 'display', visible ? 'block' : 'none');
      if (!visible) return;
      setStyle(shield, 'left', Math.round(rect.left + window.scrollX) + 'px');
      setStyle(shield, 'top', Math.round(rect.top + window.scrollY) + 'px');
      setStyle(shield, 'width', Math.round(rect.width) + 'px');
      setStyle(shield, 'height', Math.round(rect.height) + 'px');
    });
  }

  function schedule(rescan) {
    if (!isMobile() || !root) return;
    needsScan = needsScan || rescan === true;
    if (frame !== null) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      if (!isMobile()) return;
      if (!connected(root)) { stop(); return; }
      if (needsScan) { needsScan = false; scan(); }
      positionShields();
    });
  }

  function relevantTreeChange(changes) {
    return changes.some(function (change) {
      return Array.prototype.some.call(change.addedNodes, matchesMedia) ||
        Array.prototype.some.call(change.removedNodes, function (node) {
          return records.some(function (record) { return node === record.media || (node.contains && node.contains(record.media)); });
        });
    });
  }

  function motionFinished(event) {
    var target = event.target;
    if (target && records.some(function (record) {
      return target === record.media || (target.contains && target.contains(record.media));
    })) schedule(false);
  }

  function stop() {
    if (frame !== null) window.cancelAnimationFrame(frame);
    if (discoveryTimer !== null) window.clearTimeout(discoveryTimer);
    if (treeObserver) treeObserver.disconnect();
    if (mountObserver) mountObserver.disconnect();
    if (geometryObserver) geometryObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    if (root) {
      root.removeEventListener('transitionend', motionFinished, true);
      root.removeEventListener('animationend', motionFinished, true);
    }
    records.forEach(function (record) { record.shield.remove(); });
    records = [];
    root = null;
    frame = discoveryTimer = null;
    needsScan = false;
    tracking = false;
  }

  function start() {
    if (!isMobile()) { stop(); return; }
    if (root && connected(root)) { schedule(true); return; }
    stop();
    root = document.querySelector('[id^="MainProduct-"]') || document.querySelector('product-info');
    if (!root) {
      var media = document.querySelector(mediaSelector);
      root = media && (media.closest('main') || media.parentElement);
    }
    if (!root) return;
    // Attribute observers can sample the beginning of a CSS transition. Read
    // final geometry once it finishes, scoped to this gallery's ancestors.
    root.addEventListener('transitionend', motionFinished, true);
    root.addEventListener('animationend', motionFinished, true);
    treeObserver = new MutationObserver(function (changes) {
      if (relevantTreeChange(changes)) schedule(true);
    });
    // A product-scoped child-list watcher supports gallery replacement without
    // a permanent document-wide attribute observer or periodic polling.
    treeObserver.observe(root, { childList: true, subtree: true });
    watchMount();
    schedule(true);
  }

  function watchMount() {
    if (!root || discoveryTimer !== null) return;
    if (mountObserver) mountObserver.disconnect();
    mountObserver = new MutationObserver(function (changes) {
      if (changes.some(function (change) { return change.target.matches(mediaSelector); })) schedule(true);
    });
    // Some app versions assign gallery classes after inserting an empty node.
    // Stop at a successful mount; rearm if the last gallery is later removed.
    mountObserver.observe(root, { attributes: true, subtree: true, attributeFilter: ['class'] });
    discoveryTimer = window.setTimeout(function () {
      discoveryTimer = null;
      if (!records.length) stop();
    }, 90000);
  }

  function inGuardArea(target) {
    return isMobile() && target && target.closest && target.closest(guardSelector);
  }
  function installVerticalGuard() {
    window.addEventListener('touchstart', function (event) {
      if (!inGuardArea(event.target) || !event.touches || event.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { capture: true, passive: true });
    window.addEventListener('touchmove', function (event) {
      if (!tracking || !inGuardArea(event.target) || !event.touches || event.touches.length !== 1) return;
      var dx = Math.abs(event.touches[0].clientX - startX);
      var dy = Math.abs(event.touches[0].clientY - startY);
      if (dy > 8 && dy > dx * 1.1) event.stopImmediatePropagation();
    }, { capture: true, passive: true });
    window.addEventListener('touchend', function () { tracking = false; }, { capture: true, passive: true });
    window.addEventListener('touchcancel', function () { tracking = false; }, { capture: true, passive: true });
  }
  function boot() {
    installVerticalGuard();
    if (mobileQuery) {
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', start);
      else if (mobileQuery.addListener) mobileQuery.addListener(start);
    }
    window.addEventListener('resize', function () { if (root) schedule(false); else start(); }, { passive: true });
    window.addEventListener('scroll', function () { schedule(false); }, { passive: true });
    window.addEventListener('orientationchange', start, { passive: true });
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', start);
    document.addEventListener('shopify:section:load', start);
    window.addEventListener('customily-options-loaded', start);
    window.addEventListener('customily-preview-load-finished', function () { if (root) schedule(true); else start(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

/* SOULYSHINE_MATERIAL_CUSTOMILY_SYNC_V1 */
(function () {
  function syncMaterial(label) {
    if (!label || label.dataset.optionName !== 'Material') return;
    var id = label.getAttribute('for');
    var input = id ? document.getElementById(id) : null;
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var label = event.target && event.target.closest
      ? event.target.closest('label[data-option-name="Material"]')
      : null;
    if (!label) return;
    window.setTimeout(function () { syncMaterial(label); }, 0);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'Material' || !input.checked) return;
    window.setTimeout(function () {
      input.dispatchEvent(new CustomEvent('customily:material-changed', {
        bubbles: true,
        detail: { value: input.value }
      }));
    }, 0);
  }, true);
})();
